// deno-lint-ignore-file
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const tabs = makeRadioBehavior("click", "tabs__item", "tabs__item--active");
